export default "__VITE_ASSET__BzhqphBr__"